export default {
    create_account_create_title: 'Create account',
    create_account_edit_title: 'Edit account',
    create_account_the_account_was_created: 'The account was created',
    create_account_account_name: 'Account Name',
    create_account_account_name_min_error: 'The account name must contain minimum chars',
    create_account_account_name_max_error: 'The account name contain maximum chars',
    create_account_language: 'Language',
    create_account_time_zone: 'Time Zone',
    create_account_brand: 'Brand',
    create_account_dealer: 'Dealer',
    create_account_crm: 'Salesforce Id',
    create_account_crm_min_error: 'The Salesforce Id must contain minimum chars',
    create_account_internal: 'Internal',
    create_account_yes: 'Yes',
    create_account_not: 'No',
    create_account_username: 'Username',
    create_account_username_error_min: 'The username must contain minimum chars',
    create_account_username_error_max: 'The username must contain maximum chars',
    create_account_email: 'Email',
    create_account_password: 'Password',
    create_account_role: 'Role',
    create_account_report_options: 'Report Options',
    create_account_site_options: 'Site Options',
    create_account_no_options: 'No Options',
    create_account_the_account_has_been_edited: 'The account has been edited',
    create_account_general: 'General',
    create_account_packages: 'Packages',
    create_account_automatic: 'Automatic',
    create_account_manual: 'Manually',
    create_account_click_to_copy_password: 'Click to copy password!',
    create_account_the_password_was_copied: 'The password was copied',
    create_account_package: 'Package',
    create_account_select: 'Select...',
    create_account_crm_max_error: 'The Salesforce Id must contain a maximum of chars',
    create_account_promiles_username: 'Promiles Username',
    create_account_promiles_email: 'Promiles Email',
    create_account_fuel_card_company_code: 'Fuel Card Company Code',
    create_account_additional_info: 'Additional Information',
    create_account_error_username: 'The username must contain only lowercase letters and numbers, spaces are not valid',
    create_account_verify_terms_conditions: 'Verify Terms and Conditions',
    create_account_verify_terms_conditions_message: "By activating this option (YES) requires the users the acceptance of terms and conditions during the authentication process. Once accepted the T&C the system doesn't prompt for this again",
    create_account_speed_limit_engine: 'Speed Limit Engine',
    create_account_rgeo_engine: 'Rgeo Engine',
    create_account_osm_with_fallback_google: "OSM with fallback to Google",
    create_account_osm_only: "OSM Only",
    create_account_web_service_integration: "WEX EFS",
    create_account_status: "Status",
    create_account_validate_credentials: "Validate Credentials",
    create_account_active: "Active",
    create_account_inactive: "Inactive",
    create_account_fuel_card_integrations: "Fuel Card Integrations",
    create_account_wex_credencials_success: "Credentials are valid",
    create_account_wex_credencials_error: "Credentials are invalid",
    create_account_wex_credencials_message: "Credentials must be validated",
    create_account_promiles: "Promiles",
    create_account_fuel_cards: "Fuel Cards",
    create_account_web_services_status: "Web Services Status",
    create_account_tags: "Tags",
    create_account_readonly: "Read only",
    create_account_tag_mode: "Tag Mode",
    create_account_tag_mode_standard: "Standard",
    create_account_tag_mode_inheritance: "Inheritance",
};